import { render, staticRenderFns } from "./ChargingPointTypeEdit.vue?vue&type=template&id=a8d4961e"
import script from "./ChargingPointTypeEdit.vue?vue&type=script&lang=js"
export * from "./ChargingPointTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./ChargingPointTypeEdit.vue?vue&type=style&index=0&id=a8d4961e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports